import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authToken: null,
  registrationToken: null,
  sessionToken: null,
};

const tokenSlice = createSlice({
  name: 'tokens',
  initialState,
  reducers: {
    setTokens: (state, action) => {
      const { authToken, registrationToken, sessionToken } = action.payload;
      state.authToken = authToken;
      state.registrationToken = registrationToken;
      state.sessionToken = sessionToken;
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
    setRegistrationToken: (state, action) => {
      state.registrationToken = action.payload;
    },
    setSessionToken: (state, action) => {
      state.sessionToken = action.payload;
    },
    clearTokens: (state) => {
      state.authToken = null;
      state.registrationToken = null;
      state.sessionToken = null;
    },
  },
});

export const {
  setTokens,
  setAuthToken,
  setRegistrationToken,
  setSessionToken,
  clearTokens,
} = tokenSlice.actions;

export default tokenSlice.reducer;
